import * as TYPES from './types'

/**
 * Default Analytics User State
 */
export const defaultState: TYPES.AnalyticsUserState = {
  httpInProgress: false,
  httpError: '',
  userData: {
    projectID: '',
    userID: '',
    clientType: '',
    userName: '',
    country: '',
    platformOS: '',
    platformCPU: '',
    platformGPU: '',
    platformRAM: '',
    latestSessionTimestamp: 0,
    events: []
  }
}

// define initial state object
const initialState: TYPES.AnalyticsUserState = {
  httpInProgress: defaultState.httpInProgress,
  httpError: defaultState.httpError,
  userData: defaultState.userData
}

// define user reducer
export function analyticsUserReducer (
  state = initialState,
  action: TYPES.AnalyticsUserActionTypes
): TYPES.AnalyticsUserState {
  switch (action.type) {
    case TYPES.ANALYTICS_USER_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpInProgress: true, httpError: '' }
      }
    }
    case TYPES.ANALYTICS_USER_ERROR: {
      return {
        ...state,
        ...{ httpInProgress: false, httpError: action.error }
      }
    }
    case TYPES.ANALYTICS_USER_GET: {
        return {
            ...state,
            ...{ userData: action.userData },
            ...{ httpInProgress: false, httpError: '' }
        }
    }
    default:
      return state
  }
}
